import { Routes, Route } from 'react-router-dom';
import { LandingRoute } from './routes/landing';
import { ChatRoute } from './routes/chat';
import { NotFoundRoute } from './routes/not-found';
import { TestVoiceRoute } from './routes/test-voice';

/**
 * Top-level routes for chat.channel.tel.
 *
 *   /                 → landing page (links to docs / dashboard)
 *   /chat/:agentId    → embedded chat iframe UI (target of the loader script)
 *   /test-voice       → runtime proof harness for useVoice (dev only, not for prod embed)
 *   *                 → 404
 *
 * The loader script (`/widget/v1.js`) is served as a static asset by Vite from
 * `public/widget/v1.js` and never hits the React app.
 */
export function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingRoute />} />
      <Route path="/chat/:agentId" element={<ChatRoute />} />
      <Route path="/test-voice" element={<TestVoiceRoute />} />
      <Route path="*" element={<NotFoundRoute />} />
    </Routes>
  );
}
